// One name once per list, case and spacing aside — the rule the database keeps
// (categories_name_guard, 049_category_lifecycle.sql), checked here first so the
// Categories sheet can say so instead of failing.

import type { Category } from './supabase'

const key = (name: string) => name.trim().replace(/\s+/g, ' ').toLowerCase()

/** The category already called `name` (other than `exceptId`), or null. */
export function takenName(categories: Pick<Category, 'id' | 'name'>[], name: string, exceptId?: string) {
  const wanted = key(name)
  return categories.find(c => c.id !== exceptId && key(c.name) === wanted) ?? null
}
